import tw from 'twin.macro';
import Badges from '~/src/molecules/Badges/';
import Label from '~/src/atoms/Label';
import React from 'react';
import useSelectedPack from './useSelectedPack';

const RnR = ({ showRnr = true, ...rest }) => {
  if (!showRnr) return <div className="h-4 w-full"></div>;
  const { ratingInfo = {} } = useSelectedPack();
  return (
    <div css={tw`flex items-center space-x-1 h-4`} {...rest}>
      {ratingInfo?.avg_rating && <Badges className='leading-xxs' value={ratingInfo?.avg_rating} />}
     {!!ratingInfo?.rating_count && <Label css={tw`font-regular text-sm leading-xxs text-darkOnyx-200`}>
        {`${!!ratingInfo?.rating_count && ratingInfo?.rating_count} ${!!ratingInfo?.rating_count ? (ratingInfo?.rating_count > 1 ? 'Ratings' : 'Rating') : ''}`}
      </Label>}
    </div>
  );
};

export default RnR;
